import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { filledButtonColor } from '../commons/button/BasicButton/BasicButton.styled'
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'

const Error404 = () => {
  const router = useRouter()
  const { t } = useTranslation('layout')

  useEffect(() => {
    router.replace('/404')
  }, [router])

  return (
    <ErrorContent>
      <h1>404 ERROR</h1>
      <p>{parse(t(`404.desc`))}</p>
      <button onClick={() => router.replace('/')}>{t(`404.home`)}</button>
    </ErrorContent>
  )
}

export default Error404

const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  > h1 {
    ${({ theme }) => theme.font.Bold_36}
  }
  > p {
    ${({ theme }) => theme.font.Medium_16}
    text-align: center;
  }
  > button {
    margin-top: 30px;
    padding: 10px 16px;
    ${({ theme }) => theme.font.Regular_16}
    ${filledButtonColor}
  }
  @media ${({ theme }) => theme.device.mobile} {
    > h1 {
      ${({ theme }) => theme.font.Bold_24}
    }
    > p {
      ${({ theme }) => theme.font.Medium_14}
    }
    > button {
      ${({ theme }) => theme.font.Regular_14}
    }
  }
`
